import React from "react";
import ChessboardComponent from "./Chessboard";

function App() {
    return (
        <div className="App">
            <ChessboardComponent />
        </div>
    );
}

export default App;